// Componente Badge para status
import { cn } from '../../utils/cn';

interface BadgeProps {
  children: React.ReactNode;
  variant?: 'success' | 'warning' | 'danger' | 'info' | 'default';
  className?: string;
}

export function Badge({ children, variant = 'default', className }: BadgeProps) {
  const variants = {
    success: 'bg-success-100/80 text-success-800 dark:bg-success-900/50 dark:text-success-200 border border-success-200/50 dark:border-success-800/50',
    warning: 'bg-warning-100/80 text-warning-800 dark:bg-warning-900/50 dark:text-warning-200 border border-warning-200/50 dark:border-warning-800/50',
    danger: 'bg-error-100/80 text-error-800 dark:bg-error-900/50 dark:text-error-200 border border-error-200/50 dark:border-error-800/50',
    info: 'bg-primary-100/80 text-primary-800 dark:bg-primary-900/50 dark:text-primary-200 border border-primary-200/50 dark:border-primary-800/50',
    default: 'bg-gray-100/80 text-gray-800 dark:bg-gray-700/50 dark:text-gray-200 border border-gray-200/50 dark:border-gray-600/50',
  };
  
  return (
    <span
      className={cn(
        'inline-flex items-center px-3 py-1 rounded-lg text-xs font-semibold',
        'shadow-sm backdrop-blur-sm',
        'transition-all duration-200',
        variants[variant],
        className
      )}
    >
      {children}
    </span>
  );
}
